module.exports = __webpack_public_path__ + "img/bgs-scene-container3.771b7cad.png";